

















































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import firebase from 'firebase';
import moment from 'moment';

import _ from 'lodash';

import TodoService from '@/services/todo-service';

import { ToDo, TaskName } from '@/models/todo';
import { Farm } from '../models/farm';
@Component
export default class Todos extends Vue {
    @State('todos') private todosState: any;
    @Mutation('syncTodos') private syncTodosMutation: any;
    @Action('getIncompleteTodos') private getTodosAction: any;
    @State('currentFarm') private currentFarmState: any;

    private todosRef = firebase.firestore().collection('todos');
    private todoService = new TodoService();

    private TaskName = TaskName;

    private bulkCompleteTodos: Set<string> = new Set();

    private currentFarm: any = {};
    private filteredTodos: ToDo[] = [];
    private get todos() {
        return this.$store.state.todos.map((value: ToDo) => {
                this.$set(value, 'isEditing', false);
                this.$set(value, 'isHarvesting', false);
                this.$set(value, 'harvestAmount', 0);
                this.$set(value, 'uiDueDate', value.dueDate.format('YYYY-MM-DD'));
                return value;
            },
        );
    }

    private onEdit = _.debounce((todo: ToDo) => {
        todo.isEditing = true;
    }, 250);

    private onCancelEdit = _.debounce((todo: ToDo) => {
        todo.isEditing = false;
    }, 250);

    private completeTodo = _.debounce((todo: ToDo) => {
        this.todoService.completeTodo(todo.id!!);
    }, 250);

    private saveEdits = _.debounce((todo: ToDo) => {
        const { id, uiDueDate, isEditing, ...filteredTodo } = todo;
        filteredTodo.dueDate = new Date(todo.uiDueDate!!) as any;

        this.todosRef.doc(todo.id).update(filteredTodo).then((value: void) => {
            this.refreshTodos();
        });
    }, 250);

    private delayHarvest = _.debounce((todo: ToDo) => {
        this.completeTodo(todo);
        this.todosRef.doc(todo.id).get().then((value: any) => {
            const todoData = value.data() as ToDo;

            const dueDate = moment(todoData.dueDate.toDate());

            const nextDueDate = dueDate.add(todoData.harvestInterval, 'days');

            this.todoService.addTodo(
                todoData.taskName,
                nextDueDate,
                todoData.growthCycleId.id,
                todoData.growthCycleTemplateId.id,
                todoData.varietyName,
                todoData.farmId,
                todoData.rafts,
                todoData.cells,
                todoData.harvestInterval,
            );
        });
    }, 250);

    private completeHarvest = _.debounce((todo: ToDo) => {
        const updateParams = {
            harvestAmount: todo.harvestAmount,
            harvestAt: new Date(),
            isFinished: true,
        };

        todo.growthCycleId.update(updateParams);

        this.completeTodo(todo);
    }, 250);

    private trashHarvest = _.debounce((todo: ToDo) => {
        // Will enter a harvest of zero and close out the growth cycle
        this.completeTodo(todo);
    }, 250);

    private onHarvest = _.debounce((todo: ToDo) => {
        todo.isHarvesting = true;
    }, 250);

    private onCancelHarvest = _.debounce((todo: ToDo) => {
        todo.isHarvesting = false;
    }, 250);

    private addToBulk = _.debounce((todo: ToDo) => {
        this.bulkCompleteTodos.add(todo.id!!);
    }, 250);

    private onBulkComplete = _.debounce(() => {
        this.bulkCompleteTodos.forEach((todoId: string) => {
            this.todoService.completeTodo(todoId);
        });
    }, 250);

    private created(): void {
        this.refreshTodos();

        this.$store.watch((state) => {
            return [this.$store.state.currentFarm, this.$store.state.todos];
        }, ([currentFarm, todos]) => {
            this.currentFarm = currentFarm;
            this.filterTodosByFarm(currentFarm);
        }, {
            immediate: true,
        });
    }

    private filterTodosByFarm(farm: Farm) {
        this.filteredTodos = this.todos.filter((todo: ToDo) => {
            return todo.farmId.id === farm.id;
        });
    }

    private refreshTodos(): void {
        // Empty the state, then get them again in case there are new ones
        this.syncTodosMutation([]);
        this.getTodosAction();
    }
}
